<template>
    <component :is="layout">
        <router-view />
    </component>
</template>

<script>
import MainLayout from './layouts/MainLayout.vue'
import WizardLayout from './layouts/WizardLayout.vue'

export default {
    name: 'App',
    components: {
        MainLayout, WizardLayout
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || 'main') + '-layout'
        }
    },
    beforeMount(){
        this.$store.dispatch('loadConfig');
        this.$store.dispatch('users/checkUserBySession', this.$router)
    }
}
</script>
